import React from "react";
import { MapPin, Bus, Train, Car, Phone, Mail } from "lucide-react";

export default function MonasteryVisit() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 font-serif">
      <h1 className="text-2xl font-medium text-gray-800 mb-8">
        Monastery Visit
      </h1>

      {/* Calligraphy Welcome Message */}
      <div className="mb-12">
        <img
          src="https://static.wixstatic.com/media/b4e2e4_ef60da27e20b46128cbcd469a1732e98~mv2.jpg/v1/fill/w_994,h_620,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/xu-so-cua-giay-phut-hien-tai-chao-don-ba.jpg"
          alt="Welcome calligraphy by Thay"
          className="mx-auto mb-4"
        />
      </div>

      {/* Address Section */}
      <section className="mb-12">
        <h2 className="text-xl font-semibold mb-4">Address</h2>
        <p className="text-gray-700 mb-2">
          Thai Plum Village - Thap Nham Temple, Pak Chong District
          <br />
          174/176 Soi Tad Nam Rd., Moo 7, Tambon Phongtalong Nopita, Pak Chong,
          Uch Nakhon Ratchasima, Thailand
        </p>
        <p className="text-gray-600">
          From Bangkok-Korat Highway 2 (Mittraphap Road) to Pak Chong District,
          turn right at Tesco Lotus 3.5 - 4 km to reach the monastery.
        </p>
      </section>

      {/* Registration Section */}
      <section className="mb-12">
        <h2 className="text-xl font-semibold mb-4">How to Register</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li>Registration is open 3 days before start day</li>
          <li>Please fill out the registration form completely</li>
          <li>For inquiries, email: office@thaiplumvillage.com</li>
        </ul>
      </section>

      {/* Illustrated Map */}
      <section className="mb-12">
        <img
          src="https://static.wixstatic.com/media/b4e2e4_73dc0e81258f4b1c86636b5bd57e1d44~mv2.png/v1/fill/w_888,h_614,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/b4e2e4_73dc0e81258f4b1c86636b5bd57e1d44~mv2.png"
          alt="Illustrated direction map"
          className="w-full rounded-lg shadow-md"
        />
      </section>

      {/* Transportation Guide */}
      <section className="mb-12">
        <h2 className="text-xl font-semibold mb-8">Getting to the Monastery</h2>

        {/* Bus Section */}
        <div className="mb-8">
          <h3 className="text-lg font-medium flex items-center mb-4">
            <Bus className="w-5 h-5 mr-2" />
            By Bus
          </h3>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              Take bus from Mo Chit 2 Bus Terminal to Pak Chong (First bus: 5:00
              AM, Last bus: 7:30 PM)
            </li>
            <li>Inform the conductor you're going to Thai Plum Village</li>
            <li>Journey takes approximately 3 hours</li>
          </ul>
        </div>

        {/* Train Section */}
        <div className="mb-8">
          <h3 className="text-lg font-medium flex items-center mb-4">
            <Train className="w-5 h-5 mr-2" />
            By Train
          </h3>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>From Hua Lamphong Station to Pak Chong Station</li>
            <li>
              Multiple departures daily (check railway.co.th for schedules)
            </li>
            <li>
              Take a taxi or tuk-tuk from Pak Chong station to the monastery
            </li>
          </ul>
        </div>

        {/* Taxi Section */}
        <div className="mb-8">
          <h3 className="text-lg font-medium flex items-center mb-4">
            <Car className="w-5 h-5 mr-2" />
            By Taxi
          </h3>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              From Bangkok: 2,500 - 3,000 baht (negotiate price before
              departure)
            </li>
            <li>From Pak Chong: 300 - 400 baht</li>
            <li>We recommend using Grab or local taxi services</li>
          </ul>
        </div>

        {/* Private Transport */}
        <div className="mb-8">
          <h3 className="text-lg font-medium flex items-center mb-4">
            <MapPin className="w-5 h-5 mr-2" />
            By Private Vehicle
          </h3>
          <p className="text-gray-700 mb-4">
            Use Google Maps to navigate to "Thai Plum Village" or follow the
            highway signs from Bangkok.
          </p>
        </div>
      </section>

      {/* Google Maps */}
      <section className="mb-12">
        <h2 className="text-xl font-semibold mb-4">Location</h2>
        <div className="aspect-w-16 aspect-h-9">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d0!2d0!3d0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjDCsDM2JzI2LjAiTiAxMDHCsDM2JzI2LjAiRQ!5e0!3m2!1sen!2s!4v1234567890"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full rounded-lg shadow-md"
          ></iframe>
        </div>
      </section>

    
    </div>
  );
}
